<!-- The expanded listing view (HUBX-8481): the inline row's form and rules, plus the XID, the
     MPN, DQ #1-3, the popup's attribute band, the ExW point, Restrictions and the Special Notes
     chip. The top band follows the Edit modal's arrangement without copying it. -->
<form [formGroup]="fg" *ngIf="fg">
  <div class="item-wrapper"
    [class.disableddiv]="locked"
    [class._locked]="locked"
    [class._archived]="isArchived"
    [class._reduse]="!!reactivationHint"
    [class._select-active]="reactivationSelectable"
    [ngClass]="{'error-border': !!saveError}">

    <div class="item-select" *ngIf="reactivationSelectable">
      <label class="item-checkbox">
        <input type="checkbox" [checked]="reactivationChecked" (change)="toggleReactivation($event)">
        <i class="_icon"></i>
      </label>
    </div>

    <div class="item-top-info">

      <!-- Logo, and Status under it. The logo opens the v2 Edit modal, the same gesture as the
           inline row. Shown at every width. -->
      <div class="item-logo-number">
        <div class="manufacturer-logo" (click)="openEditDetailedMode()">
          <img [src]="imageBaseUrl + manufacturerLink" width="56" height="56"/>
        </div>

        <!-- status: the Edit modal's select - "You can set", then "Automatic" (disabled). -->
        <div class="item-status">
          <div class="item-info-title">Status</div>
          <select class="status-select" formControlName="skuStatus" [class.__conflict]="conflictOpen('skuStatus')"
            [class.__removed]="baseline.effectiveStatus === 'Removed'">
            <optgroup label="You can set">
              <option *ngFor="let option of assignableStatuses" [value]="option.value">{{ option.label }}</option>
            </optgroup>
            <optgroup label="Automatic">
              <option *ngFor="let option of automaticStatuses" [value]="option.value" disabled>{{ option.label }}</option>
            </optgroup>
          </select>
        </div>
      </div>

      <!-- Part Number, MPN and XID stacked, as in the Edit modal -->
      <div class="item-part-number">
        <div class="item-info-title"> Part Number </div>
        <div [tooltip]="isAll ? sellerLabel : ''"
          (click)="copyText(row.item.vendorItemCode)">
          <input type="text" class="form-control disableMe"
            formControlName="vendorItemCode" [class.__invalid]="showInvalid('vendorItemCode')" [class.__conflict]="conflictOpen('vendorItemCode')">
        </div>

        <div class="item-info-title">MPN</div>
        <input type="text" class="form-control" formControlName="mpn" [class.__invalid]="showInvalid('mpn')" [class.__conflict]="conflictOpen('mpn')">

        <span *ngIf="pricing">
          <div class="item-info-title">
            XID
          </div>
          <div [tooltip]="isAll ? sellerLabel : ''">
            <input type="text" class="form-control" formControlName="hubxItemCode" [class.__invalid]="showInvalid('hubxItemCode')" [class.__conflict]="conflictOpen('hubxItemCode')">
          </div>
        </span>

      </div>

      <!-- description, manufacturer and the category pair -->
      <div class="item-description">
        <!-- the title line carries Description's counter, on focus and while over the limit -->
        <div class="item-info-title __with-counter">Description <app-char-counter *ngIf="showDescriptionCounter" [length]="descriptionLength" [max]="descriptionMax"></app-char-counter></div>
        <textarea class="form-control" formControlName="description" [class.__invalid]="showInvalid('description')" [class.__conflict]="conflictOpen('description')"
          (focus)="descriptionFocused = true" (blur)="descriptionFocused = false"></textarea>

        <div class="item-categories">
          <!-- Native selects, as in the Edit popup: the lists are long, and a native select jumps to
               the option you start typing (app-dropdown offers no type-ahead). Enabled / disabled by
               the form itself (writableFields through applyWritability). -->
          <!-- Labelled as in the Edit modal, and level with XID (HUBX-8481). -->
          <div class="item-categories__field">
            <div class="item-info-title">Manufacturer</div>
            <select class="item-categories__native item-categories__native--manufacturer" formControlName="manufacturerId" [class.__invalid]="showInvalid('manufacturerId')" [class.__conflict]="conflictOpen('manufacturerId')"
              [title]="manufacturerName" (focus)="openOptions('manufacturerId')" (mousedown)="openOptions('manufacturerId')">
              <option value="" disabled hidden>Select</option>
              <option *ngFor="let man of optionsFor('manufacturerId', lookups.manufacturers, 'id')" [value]="man.id">{{ man.name }}</option>
            </select>
          </div>
          <div class="item-categories__field">
            <div class="item-info-title">Category</div>
            <select class="item-categories__native item-categories__native--main" formControlName="categoryMainId" [class.__invalid]="showInvalid('categoryMainId')" [class.__conflict]="conflictOpen('categoryMainId')"
              (focus)="openOptions('categoryMainId')" (mousedown)="openOptions('categoryMainId')">
              <option value="" disabled hidden>Select</option>
              <option *ngFor="let cat of optionsFor('categoryMainId', lookups.categories, 'categoryId')" [value]="cat.categoryId">{{ cat.name }}</option>
            </select>
          </div>
          <div class="item-categories__field" *ngIf="subCategories.length">
            <div class="item-info-title">Subcategory</div>
            <select class="item-categories__native" formControlName="categoryId" [class.__invalid]="showInvalid('categoryId')" [class.__conflict]="conflictOpen('categoryId')"
              (focus)="openOptions('categoryId')" (mousedown)="openOptions('categoryId')">
              <option value="" disabled hidden>Select</option>
              <option *ngFor="let sub of optionsFor('categoryId', subCategories, 'categoryId')" [value]="sub.categoryId">{{ sub.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- promo: the popup's three icons -->
      <div class="item-promo">
        <div class="item-info-title">Promo</div>
        <div class="item-promo-group">
          <!-- Today's Deals: the Edit modal's toggle when writableFields grants it (role=switch,
               as in the modal); the plain icon otherwise. Its state is the row's form, so an
               unsaved toggle shows here until Save or Undo. -->
          <a *ngIf="mayCurate; else todaysDealsIcon" role="switch" tabindex="0" class="item-icon-btn __toggle"
            [attr.aria-checked]="inTodaysDeals" [class.disabled]="!inTodaysDeals"
            [class.__conflict]="conflictOpen('todaysDeals')"
            (click)="toggleTodaysDeals()" (keydown.enter)="toggleTodaysDeals()" (keydown.space)="$event.preventDefault(); toggleTodaysDeals()"
            [tooltip]="todaysDealsTooltip" placement="top" container="body">
            <img
              [src]="inTodaysDeals ? 'assets/images/vendor-icons/today-deal-active.svg' : 'assets/images/vendor-icons/today-deal-inactive.svg'" alt="Today's Deals" />
          </a>
          <ng-template #todaysDealsIcon>
            <a role="button" class="item-icon-btn __no-events" [class.disabled]="!inTodaysDeals">
              <img
                [src]="inTodaysDeals ? 'assets/images/vendor-icons/today-deal-active.svg' : 'assets/images/vendor-icons/today-deal-inactive.svg'" alt="Today's Deals" />
            </a>
          </ng-template>
          <a role="button" class="item-icon-btn __no-events" [class.disabled]="!row.priceDrop">
            <img
              [src]="row.priceDrop ? 'assets/images/vendor-icons/price-drop-active.svg' : 'assets/images/vendor-icons/price-drop-inactive.svg'" />
          </a>
          <a role="button" class="item-icon-btn __no-events" [class.disabled]="!row.justLaunched">
            <img
              [src]="row.justLaunched ? 'assets/images/vendor-icons/just-launched-active.svg' : 'assets/images/vendor-icons/just-launched-inactive.svg'" />
          </a>
        </div>
      </div>

      <div class="item-availability">
        <!-- available -->
        <div class="item-info-title">Available</div>
        <div>
          <input appOnlyDigits type="number" class="form-control" formControlName="availability" [class.__invalid]="showInvalid('availability')" [class.__conflict]="conflictOpen('availability')">
        </div>

        <!-- eta -->
        <span>
          <div class="item-info-title">ETA</div>
          <div>
            <input appOnlyDigits type="number" class="form-control" formControlName="leadTimeDays" [class.__invalid]="showInvalid('leadTimeDays')" [class.__conflict]="conflictOpen('leadTimeDays')">
          </div>
        </span>
      </div>

      <div class="item-moq-group">

        <!-- moq -->
        <div class="item-info-title" [tooltip]="'Minimum Order Quantity'" containerClass="moqdq" placement="top">
          MOQ
        </div>

        <div class="input-qty">
          <input type="text" class="form-control" [class.error]="fg.errors?.moqExceedsMxq"
            formControlName="moq" [class.__invalid]="showInvalid('moq')" [class.__conflict]="conflictOpen('moq')" mask="10*" [validation]="false" [patterns]="customPatterns">
        </div>

        <!-- MXQ -->
        <div class="item-info-title" [tooltip]="'Maximum Order Quantity'" containerClass="moqdq" placement="top">
          MXQ
        </div>
        <div class="input-qty">
          <input type="text" class="form-control" [class.error]="fg.errors?.moqExceedsMxq"
            formControlName="mxq" [class.__invalid]="showInvalid('mxq')" [class.__conflict]="conflictOpen('mxq')" mask="0*" [validation]="false">
        </div>

      </div>

      <!-- Cost, and Price under it (ADMIN / VM), as in the Edit modal -->
      <div class="item-cost-price __cost" [class.red-border]="!!reactivationHint">
        <div class="item-info-title">
          Cost
        </div>
        <div class="input-price" [class.not-empty]="fg.controls.cost.value !== null">
          <input type="text" class="form-control" formControlName="cost" [class.__invalid]="showInvalid('cost')" [class.__conflict]="conflictOpen('cost')"
            prefix='$' mask="separator.2" thousandSeparator=",">
          <!-- Removed row: the cut that reactivates it, on hover (legacy parity) -->
          <div class="reduse-cost-tooltip" *ngIf="showReduceCost" [class.for-seller]="role === 'SELLER'">
            <div class="reduse-cost-body">
              <div class="reduse-cost-header">
                <h3>0 items were sold within a week</h3>
              </div>
              <div class="reduse-cost-content">
                <p>To activate listing, <br> you must reduce cost <br> by at least {{ reductionPercent }}%</p>
                <div class="reduse-cost-content__ctrl">
                  <button type="button" class="btn" (click)="applyReactivationThreshold()">
                    <span>Reduce to {{ row.reactivationThreshold | CustomCurrency }}</span>
                  </button>
                </div>
              </div>
              <div class="reduse-cost-footer">
                <span>The above cost is the minimum requirement to activate the status</span>
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="pricing">
          <div class="item-info-title">
            Price
          </div>
          <div class="input-price" [ngClass]="{'not-empty': fg.controls.unitPrice.value !== null}">
            <input type="text" class="form-control" formControlName="unitPrice" [class.__invalid]="showInvalid('unitPrice')" [class.__conflict]="conflictOpen('unitPrice')"
              prefix='$' mask="separator.2" thousandSeparator=","
              [class.error]="fg.errors?.unitPriceBelowCost">
          </div>
        </ng-container>
      </div>

      <!-- DQ #1-3: all three slots for ADMIN / VM, empty ones included, as in the Edit modal.
           Never drawn for a Seller (dqSlots is empty). -->
      <ng-container formArrayName="discountQtys">
        <div class="item-dq" *ngFor="let tier of dqSlots; let i = index">
          <div class="item-info-title" [tooltip]="'Discount Quantity'" containerClass="moqdq" placement="top">
            DQ #{{i+1}}
          </div>
          <div class="input-group-vertical" [formGroupName]="i">
            <div class="input-qty">
              <input type="text" class="form-control" formControlName="fromQty"
                (blur)="checkPrefix(qtyInput)" prefix='<' mask="0*" #qtyInput
                [class.__invalid]="showDqInvalid(tier, 'fromQty')">
            </div>
            <div class="input-price disc" [class.not-empty]="tier.controls['price'].value !== null">
              <input type="text" class="form-control" formControlName="price"
                (blur)="checkPrefix(tierPrice)" prefix='$' mask="separator.2" thousandSeparator="," #tierPrice
                [class.__invalid]="showDqInvalid(tier, 'price')">
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="item-bottom-info">
      <!-- launched -->
      <div class="launched">
        <span> {{ row.lastActivatedOn ? 'Launched' : '' }}</span>
        <span>{{ row.lastActivatedOn ? ( row.lastActivatedOn | date:'M/d/yy, h:mm' ) : '' }}</span>
      </div>
      <div class="category-select">
      </div>

      <!-- the attribute band, in the Edit modal's order: the three attributes, ExW, Restrictions, Special Notes -->
      <div class="item-attributes">
          <select class="item-bottom-select input-group-condition" formControlName="condition" [class.__invalid]="showInvalid('condition')" [class.__conflict]="conflictOpen('condition')"
            (focus)="openOptions('condition')" (mousedown)="openOptions('condition')">
            <option *ngFor="let cond of optionsFor('condition', lookups.condition?.values, 'code')" [value]="cond.code">{{cond.value}}</option>
          </select>

          <select class="item-bottom-select input-group-warranty" formControlName="warranty" [class.__invalid]="showInvalid('warranty')" [class.__conflict]="conflictOpen('warranty')"
            (focus)="openOptions('warranty')" (mousedown)="openOptions('warranty')">
            <option *ngFor="let wart of optionsFor('warranty', lookups.warranty?.values, 'code')" [value]="wart.code">{{wart.value}}</option>
          </select>

          <select class="item-bottom-select input-group-packaging" formControlName="packaging" [class.__invalid]="showInvalid('packaging')" [class.__conflict]="conflictOpen('packaging')"
            (focus)="openOptions('packaging')" (mousedown)="openOptions('packaging')">
            <option *ngFor="let pckg of optionsFor('packaging', lookups.packaging?.values, 'code')" [value]="pckg.code">{{pckg.value}}</option>
          </select>

          <select class="item-bottom-select input-group-exw" formControlName="exwId" [class.__invalid]="showInvalid('exwId')" [class.__conflict]="conflictOpen('exwId')"
            (focus)="openOptions('exwId')" (mousedown)="openOptions('exwId')">
            <option *ngFor="let exw of optionsFor('exwId', lookups.exwPoints, 'id')" [value]="'' + exw.id">{{exw.description}}</option>
          </select>

          <!-- Restrictions is text in v2: "Yes" is there being some. -->
          <div class="restrictions-select" [class.edit-visible]="hasRestrictions">
            <select #restrictionsSelect class="item-bottom-select input-group-restrictions"
              [disabled]="restrictionsLocked"
              (change)="onRestrictionsChoice($any($event.target).value)">
              <option value="No" [selected]="!hasRestrictions">No</option>
              <option value="Yes" [selected]="hasRestrictions">Yes</option>
            </select>
            <div class="restrictions-select-right" *ngIf="hasRestrictions">
              <!-- the app tooltip, as on the Special Notes chip and in the Edit modal -->
              <div class="restrictions-select-right__txt" [tooltip]="restrictionsTooltip" placement="top" container="body">
                {{ fg.controls.restrictions.value }}
                <span class="_shadow"></span>
              </div>
              <span class="restrictions-select-right__btn" *ngIf="!restrictionsLocked" (click)="editRestrictions()">Edit</span>
            </div>
          </div>

          <!-- Special Notes: the Edit modal's chip. No label beside it, like the rest of the band:
               it reads "Special Notes" while empty, the note once there is one, and the tooltip
               always names it. -->
          <div class="item-note-chip" role="button" aria-label="Special Notes"
            [class.has-text]="hasNotes" [class.__disabled]="notesLocked" (click)="editNotes()"
            [tooltip]="notesTooltip" placement="top" container="body">
            <i class="item-note-chip__icon __notes"></i>
            <span class="item-note-chip__state">{{ notesText }}</span>
            <span class="item-note-chip__action" *ngIf="!notesLocked">{{ hasNotes ? 'Edit/View' : 'Add' }}</span>
          </div>

      </div>

      <div class="updated">
        <span> {{ row.lastUpdatedOn ? 'Updated' : '' }}</span>
        <span> {{ row.lastUpdatedOn ? ( row.lastUpdatedOn | date:'M/d/yy, h:mm' ) : '' }}</span>
      </div>
      <!-- Launched / Updated once the band is too narrow for the two dates (1280px and under,
           where .launched and .updated hide): an icon of its own, between Special Notes and
           Clone, whose hover shows them. The action buttons no longer open the dates over their
           own tooltips (HUBX-8466). -->
      <div class="item-icon-btn item-dates has-item-btn-tooltip" tabindex="0" role="img" aria-label="Launched and Updated dates">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="8" stroke="#191a19" stroke-width="2"/>
          <path d="M12 7.5V12L15 14" stroke="#191a19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="item-btn-tooltip item-dates__tooltip">
          <div class="__launched">
            <span>{{ row.lastActivatedOn ? 'Launched' : '' }}</span>
            <span>{{ row.lastActivatedOn ? ( row.lastActivatedOn | date:'M/d/yy, h:mm' ) : '' }}</span>
          </div>
          <div class="__updated">
            <span>{{ row.lastUpdatedOn ? 'Updated' : '' }}</span>
            <span>{{ row.lastUpdatedOn ? ( row.lastUpdatedOn | date:'M/d/yy, h:mm' ) : '' }}</span>
          </div>
        </div>
      </div>
      <div class="control-btns">

        <a role="button" class="item-icon-btn clone has-item-btn-tooltip" (click)="triggerClone($event)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8.5" y="8.5" width="11" height="11" rx="2" stroke="#4586D5" stroke-width="2"/>
            <path d="M15.5 5.5H6.5C5.39543 5.5 4.5 6.39543 4.5 7.5V16.5" stroke="#4586D5" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <div class="item-btn-tooltip">Clone</div>
        </a>
        <a role="button" class="item-icon-btn has-item-btn-tooltip"
          [ngClass]="{'vendor-item-updated': isEdited}"
          (click)="undoItemUpdates($event)" placement="bottom">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="m6.00421756 12c0 3.3145476 2.685161 6 5.99819244 6 3.3130315 0 5.9981925-2.6854524 5.9981925-6 0-2.93735818-2.1307842-5.42920384-4.9978674-5.90946034l-.3577692-.05992884v-3.01214526l.4814055.05980358c4.4775011.55622674 7.8736286 4.37074396 7.8736286 8.92173086 0 4.9716573-4.0279056 9-8.99759 9-4.96968431 0-8.99758993-4.0283427-8.99758993-9 0-2.08356377.71259734-4.052563 1.99325746-5.63828975l-1.39602921-1.39460219-.10570299-.10190197c-.06353372-.06205206-.11475278-.11449547-.16190711-.16674877-.21437519-.23755639-.33443822-.46158458-.33443822-.73417161 0-.53166627.43160298-.96428571.96413509-.96428571h5.35563658c.14451306 0 .28211456.01920102.44139649.09157803.32099494.14585869.52273864.45091876.52273864.87270768v5.35714286c0 .53154704-.43202033.96428573-.96413513.96428573-.32186896 0-.51778503-.1144239-.7985355-.39298086l-.23290517-.23937411-1.14870224-1.14942643c-.73244391 1.01204442-1.1354112 2.2226953-1.1354112 3.4960671z" fill="#191a19"/></svg>
          <div class="item-btn-tooltip">Undo</div>
        </a>
        <!-- Dimmed while a conflict is unresolved, the form refuses the edit, or the server
             refused it and it is unchanged since (HUBX-8466); the tooltip says which. -->
        <a role="button" class="item-icon-btn update has-item-btn-tooltip" (click)="updateSingleItem()"
          [ngClass]="{'vendor-item-updated': canSave}" [attr.aria-disabled]="!canSave">
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
            <path fill="#191a19" d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" />
          </svg>
          <div class="item-btn-tooltip">{{ saveTooltip }}</div>
        </a>

        <div class="item-archive-controls" *ngIf="mayArchive">
          <a role="button" class="item-archive-controls__btn restore has-item-btn-tooltip"
          *ngIf="isArchived"
          (mouseenter)="tooltipMsg = 'Archived'" (click)="restoreItem()">Restore</a>
          <a role="button" class="item-archive-controls__btn archive has-item-btn-tooltip"
          *ngIf="!isArchived"
          (mouseenter)="tooltipMsg = 'Archive'" (click)="archiveItem()">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g fill="#EB3B44" fill-rule="nonzero">
                  <polygon points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"></polygon>
                </g>
              </g>
            </svg>
          </a>
          <div class="item-btn-tooltip">{{tooltipMsg}}</div>
        </div>
      </div>
    </div>

    <div class="center-block">
      <div *ngIf="reactivationHint" class="__reduse-cost">
        <img src="/assets/images/alert.svg" width="24px" height="24px" />
        <span>{{ reactivationHint }}</span>
      </div>

      <!-- what SAVE will do beyond what was typed: the popup's notices, in its amber
           (nothing failed, so never the red banner) -->
      <div class="item-save-notice col-md-12" *ngFor="let notice of notices">
        <span>{{ notice }}</span>
      </div>

      <!-- a 412 on this row's last save (HUBX-8478): the Edit modal's amber notice. Save stays
           blocked until the row is resolved in the resolve popup (HUBX-8466). -->
      <div class="item-conflict-line col-md-12" *ngIf="conflictNotice">
        <span>{{ conflictNotice }}</span>
        <button type="button" class="item-conflict-line__action" (click)="reviewConflict()">{{ reviewLabel }}</button>
      </div>

      <div class="line-error col-md-12" *ngIf="errorLine">
        <img [src]="imageBaseUrl + '/assets/images/exclamation-mark.svg'" width="24px" height="24px" />
        <span>{{ errorLine }}</span>
      </div>

      <!-- the success mark (HUBX-8478): in the error's slot, a check rather than an
           exclamation so it reads without colour; it fades (the page clears it). -->
      <div class="line-saved col-md-12" *ngIf="showSaved" role="status">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="#2E9E6B"
          stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" stroke-width="2"/><path d="m7.5 12.5 3 3 6-6.5"/>
        </svg>
        <span>{{ savedText }}</span>
      </div>
    </div>
  </div>

  <!-- inside the form: it reads the Restrictions select above -->
  <app-item-text-modal *ngIf="editingRestrictions"
    title="Restrictions"
    [value]="fg.controls.restrictions.value || ''"
    placeholder="Describe the restrictions"
    (saved)="onRestrictionsSaved($event)"
    (closedModal)="onRestrictionsClosed(); restrictionsSelect.value = hasRestrictions ? 'Yes' : 'No'">
  </app-item-text-modal>

  <app-item-text-modal *ngIf="editingNotes"
    title="Special Notes"
    [value]="fg.controls.specialNotes.value || ''"
    (saved)="onNotesSaved($event)"
    (closedModal)="onNotesClosed()">
  </app-item-text-modal>
</form>
